import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "currency-select d-flex align-c" }
const _hoisted_2 = { class: "dropdown ml-1" }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = {
  class: "menu",
  style: {"max-height":"300px"}
}
const _hoisted_5 = ["onClick"]

import { currency_formats } from '@/utils/checkout'
import { ref } from 'vue'
import { strings } from '@/strings'
import Icon from '@/components/icons/icon.vue'
import { localstore } from '@/utils/localstorage'
import { router } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'currency-select',
  setup(__props) {

const selected = ref(localstore.get('currency'))
const active = ref(false)

const select = (curr: string) => {
  selected.value = curr
  localstore.set('currency', curr)
  setTimeout(() => {
    hide();
    router.replace({ name: 'pricing', query: {'c':  curr} })
  })
}

const toggle = () => {
  active.value = !active.value
}

const hide = () => {
  active.value = false
}

const currencies = Object.assign({}, currency_formats)
delete currencies['www']


return (_ctx: any,_cache: any) => {
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("small", null, _toDisplayString(_unref(strings).pricing['13']), 1),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "toggle",
        onClick: toggle
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(selected.value.toUpperCase()), 1),
        _createVNode(Icon, {
          class: "select-icon ml-075",
          icon: "arrowDown"
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencies), (_, c) => {
          return (_openBlock(), _createElementBlock("a", {
            key: c,
            onClick: ($event: any) => (select(c)),
            style: {"display":"block"},
            class: _normalizeClass({'active': c === selected.value})
          }, [
            _createElementVNode("span", null, _toDisplayString(c), 1)
          ], 10, _hoisted_5))
        }), 128))
      ], 512), [
        [_vShow, active.value]
      ])
    ])), [
      [_directive_blur, hide]
    ])
  ]))
}
}

})